import React from 'react'
import DropdownManagementFeature from '../../../features/FieldManagement/DropdownManagement/DropdownManagement'

const DropdownManagement = () => {
    return (
        <DropdownManagementFeature />
    )
}

export default DropdownManagement